import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/fonts.scss";
import "./scss/App.scss";
// Toasts are used on employee pages too (Profile, ConsentModal); this used to arrive only via the back-office pages.
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import { EventType, InteractionType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";
import { BrowserRouter } from "react-router-dom";
import "./newrelic";
import {
  accessErrorFromMsal,
  clearLoginError,
  saveLoginError,
} from "./helpers/accessError";
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';

/*if (pathname === '/backoffice') {
  editmslConfig.auth.redirectUri = msalConfig.auth.redirectUri + pathname;
}*/

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Keep the reason a redirect sign-in failed (locked/disabled account, not assigned, ...) for the Login page.
msalInstance.addEventCallback((event) => {
  const redirectTokenFailure =
    event.eventType === EventType.ACQUIRE_TOKEN_FAILURE && event.interactionType === InteractionType.Redirect;
  if ((event.eventType === EventType.LOGIN_FAILURE || redirectTokenFailure) && event.error) {
    saveLoginError(accessErrorFromMsal(event.error));
  } else if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.interactionType === InteractionType.Redirect)
  ) {
    clearLoginError();
  }
});
root.render(
  <>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </BrowserRouter>
  </>
);
//serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
